import React from 'react'

import {
  CopilotStep,
  useCopilot,
  walkthroughable,
} from '@zet/common/components/coachMarks'
import { Stack } from '@zet/design-system'
import { isEmpty } from 'lodash'

const CopilotStack = walkthroughable(Stack)

const CoachMarks = (props: {
  text: string
  order: number
  name: string
  children: React.ReactNode
}) => {
  const value = useCopilot()

  if (isEmpty(value)) return props.children

  return (
    <CopilotStep text={props.text} order={props.order} name={props.name}>
      <CopilotStack>{props.children}</CopilotStack>
    </CopilotStep>
  )
}

export { CoachMarks }
